import { type ApiResponse } from '@webapp/core/interfaces/api/ApiResponse'
import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error/throwRepoErrorFromApiV3Error'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type RequestableApproverOptionConstructor } from '@webapp/modules/expense/entities/RequestableApproverOption'
import {
  type IApproverRepository,
  type RequestableApproverParams,
} from '../../../business-logic/interfaces/IApproverRepository'
import { type RequestableApproverOptionApiModel } from '../../api-models/RequestableApproverOptionApiModel'
import { mapRequestableApproverOptionApiModel } from '../../mappers/mapRequestableApproverOptionApiModel'

export type { RequestableApproverParams }

interface Dependency {
  httpClient: IHttpClient
}

export class ApproverRepository implements IApproverRepository {
  constructor(private readonly deps: Dependency) {}

  async listRequestableApprovers(
    params: RequestableApproverParams
  ): Promise<RequestableApproverOptionConstructor[]> {
    try {
      const res = await this.deps.httpClient.post<
        ApiResponse<RequestableApproverOptionApiModel[]>
      >(`/api/v3/approvers/requestable/`, {
        base_content_type_id: params.baseContentTypeId,
        department: params.department,
        account_code_ids: params.accountCodeIds,
        custom_fields: params.customFields,
        amount: params.amount,
      })

      return res.data.data.map((apiModel) =>
        mapRequestableApproverOptionApiModel(apiModel)
      )
    } catch (err) {
      throwRepoErrorFromApiV3Error(err)
    }
  }
}
